import React from "react";

import { Data } from "ui/Graph/util";
import { useDateRange } from "providers/WithDateRange";
import QueryPerformanceGraph from "features/Queries/QueryPerformanceGraph";

import { useServerGroupPerDatabaseQueryGraphQuery } from "./gql/Query.generated";

function QueryGraph({
  serverGroupId,
  datname,
  className,
}: {
  serverGroupId: string;
  datname: string;
  className?: string;
}) {
  const { from, to } = useDateRange();

  const { data, loading, error } = useServerGroupPerDatabaseQueryGraphQuery({
    variables: {
      serverGroupId,
      datname,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  return (
    <QueryPerformanceGraph
      data={data?.getQueryOverviewStatsForDatabaseGroup as unknown as Data}
      loading={loading}
      error={error}
      className={className}
    />
  );
}

export default QueryGraph;
